import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {SharedService} from "../../services/store/shared-store/shared-storage.service";

@Component({
  selector: 'app-flow-management',
  templateUrl: './flow-management.component.html',
  styleUrls: ['./flow-management.component.scss'],
})
export class FlowManagementComponent {
  constructor(public dialogRef: MatDialogRef<FlowManagementComponent>,public sharedService: SharedService) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
